import { formatTitle } from "utils/formatTitle";

const TEMPLATE_FEE_CATEGORIES = [
  "applicant_administration_fee",
  "applicant_holding_fee"
] as const;

export const isTemplateFeeCategory = (category: string) =>
  TEMPLATE_FEE_CATEGORIES.includes(
    category as (typeof TEMPLATE_FEE_CATEGORIES)[number]
  );

// Format the display name
export const getDisplayName = (category: string, description: string) => {
  switch (category) {
    case "applicant_verification_rental_application_fee":
      return "Rental application";
    case "applicant_verification_credit_report_fee":
      return "Credit report";
    case "applicant_verification_eviction_report_fee":
      return "Eviction report";
    case "applicant_verification_income_verification_fee":
      return "Income verification";
    case "applicant_verification_criminal_report_fee":
      return "National criminal report (US)";
    case "applicant_verification_housing_history_fee":
      return "Housing history";
    case "applicant_verification_verified_income_verification_fee":
      return "Verified income";
    case "applicant_verification_submission_disclosure_fee":
      return "Submission disclosure";
    case "partner_boom_report_ongoing_fee":
      return "Boom report";
    case "applicant_verification_identity_verification_fee":
      return "Identity verification";
    case "credit_card_processing_fee":
      return "Credit card processing fee";
    case "refund":
      return "Refund";
    case "applicant_application_fee":
      return "Application fee";
    case "applicant_administration_fee":
      return "Administration fee";
    case "applicant_holding_fee":
      return "Holding fee";
    default: {
      const criminalMatch = /BoomScreen Fee for Criminal report (\d+)/.exec(
        description
      );
      if (criminalMatch) return `County walk-in search ${criminalMatch[1]}`;
      if (/BoomScreen Fee for Canadian criminal report /.exec(description))
        return "National criminal report (CA)";
      if (/BoomScreen Fee for Rental\s+verification/.exec(description))
        return "Rental verification";
      return description === "credit_report_05402"
        ? "Credit report"
        : formatTitle(description, {}, false);
    }
  }
};
